import { useEffect } from 'react';
import { useAuth, useUser } from '@clerk/clerk-react';

// ID de la extensión en producción
// Si cambia la clave en manifest.json, este ID cambiará.
const EXTENSION_ID = 'iobnadjkbhmdoboancpnmglacknijlbk';

export const ExtensionSync = () => {
  const { isSignedIn, getToken } = useAuth();
  const { user } = useUser();

  useEffect(() => {
    // 1. Proactive synchronization when auth state changes
    const syncToken = async () => {
      if (isSignedIn && user) {
        try {
          const token = await getToken();
          if (token) {
            console.log("📢 Detectada sesión activa, sincronizando con la extensión...");

            // Método 1: PostMessage (para el content script de la extensión)
            // Este es el método más fiable si la extensión inyecta scripts
            window.postMessage({ 
              type: "SYNC_CLERK_SESSION", 
              token: token, 
              user: {
                id: user.id,
                email: user.primaryEmailAddress?.emailAddress,
                fullName: user.fullName,
                imageUrl: user.imageUrl,
              } 
            }, "*");
            console.log("📢 Token enviado vía postMessage (SYNC_CLERK_SESSION)");

            // Método 2: Chrome Runtime Directo (si es 'externally_connectable')
            if (window.chrome && window.chrome.runtime && window.chrome.runtime.sendMessage) {
              window.chrome.runtime.sendMessage(EXTENSION_ID, {
                type: 'SYNC_CLERK_SESSION',
                token,
                user: {
                  id: user.id,
                  email: user.primaryEmailAddress?.emailAddress,
                  fullName: user.fullName,
                  imageUrl: user.imageUrl,
                },
              }, (response) => {
                if (window.chrome.runtime.lastError) {
                  console.warn("⚠️ Error enviando mensaje directo a la extensión:", window.chrome.runtime.lastError.message);
                  return;
                }
                console.log("📢 Token enviado directamente a la extensión:", response);
              });
            }
          }
        } catch (err) {
          console.error("❌ Error en la sincronización del token:", err);
        }
      }
    };

    syncToken();

    // 2. Reactive synchronization (Phoenix): Listen for requests from the extension
    const handleMessage = (message: any, _sender: any, sendResponse: (response?: any) => void) => {
      if (message.type === 'GET_CLERK_SESSION' && isSignedIn) {
        getToken().then((token: string | null) => {
          if (token) {
            sendResponse({ 
              token, 
              user: {
                id: user?.id,
                email: user?.primaryEmailAddress?.emailAddress,
                fullName: user?.fullName,
                imageUrl: user?.imageUrl,
              }
            });
          } else {
            sendResponse({ error: 'no_token' });
          }
        }).catch(() => {
          sendResponse({ error: 'clerk_error' });
        });
        return true; // Keep channel open for async response
      }
    };

    // Note: onMessageExternal is for messages from extension to web page
    // if the page is explicitly listed in externally_connectable.
    // However, usually we use window.addEventListener for custom events or 
    // a more direct bridge if the extension injects a script.
    // In this architecture, the extension uses chrome.tabs.sendMessage.
    
    if (window.chrome && window.chrome.runtime && window.chrome.runtime.onMessage) {
      window.chrome.runtime.onMessage.addListener(handleMessage);
      return () => window.chrome.runtime.onMessage.removeListener(handleMessage);
    }
  }, [isSignedIn, user, getToken]);

  return null; // Componente "headless" (sin UI)
};